import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FeatureCard } from '../../ng-for-business.models';

@Component({
  selector: 'app-ng-business-feature-grid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './feature-grid.component.html',
  styleUrls: ['./feature-grid.component.scss'],
})
export class FeatureGridComponent {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) subtitle!: string;
  @Input({ required: true }) features!: FeatureCard[];

  trackByIcon = (_: number, feature: FeatureCard) => feature.icon;
}
